import React from 'react'
import '../../../styles/classroom/ClassroomHome.css'

const ClassroomTrendSkeleton = () => {
    return (
        <div className="classroom-dashwidget-container animate-pulse">
            {/* Gornji deo sa naslovom i dugmićima */}
            <div className="classroom-widget-left flex-2">
                <div className="widget-left-top w-full flex flex-col  ">
                    {/* Naslov */}
                    <div className="h-[25px] w-[172px]  rounded bg-lightBG"></div>

                    {/* Period buttons */}
                    <div className="flex-1 flex flex-row gap-3 items-center justify-between">
                        <span></span>
                        {[...Array(4)].map((_, idx) => (
                            <div key={idx} className="h-[30px] w-[115px] bg-lightBG rounded-full"></div>
                        ))}
                    </div>

                    {/* Skriven placeholder */}
                    <div className="h-6 w-48 bg-lightBG rounded opacity-0"></div>
                </div>

                {/* Donji deo sa emocijama */}
                <div className=" flex flex-row gap-[10px] ">
                    {[...Array(2)].map((_, idx) => (
                        <div key={idx} className="positive-emotion-container  items-center  " style={{ minHeight: 125 }}>
                            {/* Leva strana */}
                            <div className="flex flex-col w-full gap-3">
                                <div className="h-4 w-36 bg-lightBG rounded"></div>

                                <div className="flex flex-row gap-2 items-center">
                                    {[...Array(5)].map((__, i) => (
                                        <div key={i} className="w-[30px] h-[30px] bg-lightBG rounded-full"></div>
                                    ))}
                                </div>
                            </div>

                            {/* Desna strana */}
                            <div className="flex flex-col items-center gap-2 ">
                                <div className="w-10 h-5 bg-lightBG rounded"></div>
                                <div className="w-[38px] h-[38px] bg-lightBG rounded-full"></div>
                            </div>
                        </div>
                    ))}
                    <div className="positive-emotion-container  items-center  " style={{ minHeight: 125, flex: 1 }}>
                        <div className="flex flex-row items-center gap-2 flex-1">
                            <div className="w-[45px] h-[45px] bg-lightBG rounded-full"></div>
                            <div className="flex flex-col gap-1">
                                <div className="w-[30px] h-[30px] bg-lightBG rounded"></div>
                                <div className="w-[30px] h-5 bg-lightBG rounded"></div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="w-[120px] h-5 bg-lightBG rounded"></div>
                                <div className="w-[120px] h-5 bg-lightBG rounded"></div>
                            </div>
                        </div>
                        <div className="flex flex-row items-center gap-2 flex-1">
                            <div className="w-[45px] h-[45px] bg-lightBG rounded-full"></div>
                            <div className="flex flex-col gap-1">
                                <div className="w-[30px] h-[30px] bg-lightBG rounded"></div>
                                <div className="w-[30px] h-5 bg-lightBG rounded"></div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="w-[120px] h-5 bg-lightBG rounded"></div>
                                <div className="w-[120px] h-5 bg-lightBG rounded"></div>
                            </div>
                        </div>
                        <div className="flex flex-row items-center gap-2 flex-1">
                            <div className="w-[45px] h-[45px] bg-lightBG rounded-full"></div>
                            <div className="w-[120px] h-5 bg-lightBG rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClassroomTrendSkeleton
